import { useId } from "react";
import clsx from "clsx";
import { ResignationForm } from "./resignation-form.tsx";
import overlayStyles from "../shared/offboarding-page-overlay.module.css";
import styles from "./resignation-form-modal.module.css";

export interface ResignationFormModalProps {
    open: boolean;
    offboardingId: number;
    onSubmitSuccess: () => void;
}

/** Page-scoped resignation form dialog (does not cover sidebar/header). */
export function ResignationFormModal({
    open,
    offboardingId,
    onSubmitSuccess,
}: ResignationFormModalProps) {
    const titleId = useId();

    if (!open) return null;

    return (
        <div className={overlayStyles.overlay} role="presentation">
            <div
                className={overlayStyles.dialog}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                onClick={(e) => e.stopPropagation()}
            >
                <header className={styles.header}>
                    <h2 id={titleId} className={clsx("heading-lg", styles.title)}>
                        Offboarding Request Form
                    </h2>
                </header>
                <div className={styles.body}>
                    <ResignationForm
                        offboardingId={offboardingId}
                        onSubmitSuccess={onSubmitSuccess}
                    />
                </div>
            </div>
        </div>
    );
}
